export default "<div id=\"container\">\n  <strong>{{ name }}</strong>\n  <p>The Next Step in Music Education</p>\n</div>";